module.exports = __webpack_public_path__ + "img/q2a2.174a7174.png";